import _ from 'underscore';

import { waitForImageLoad } from '@trello/image-previews';
import { unsplashClient } from '@trello/unsplash';

import { createMenuState } from 'app/src/components/CreateBoardPopover/createMenuState';
import { PRELOAD_PHOTO_EXPIRATION } from './CreateBoard.constants';

// Expire memoization cache so we don't keep stale responses around too long
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const delayedExpireMemoizedCache = (fn: any, ms = 0) =>
  setTimeout(() => (fn.cache = {}), ms);

const preloadPhotos = _.memoize(() => {
  delayedExpireMemoizedCache(preloadPhotos, PRELOAD_PHOTO_EXPIRATION);

  return unsplashClient.getDefaultCollection().then(({ response }) =>
    // Preload photos visible on initial create board screen then resolve with the initial response
    Promise.all(
      response?.results?.map((photo) => waitForImageLoad(photo.urls.small)) ||
        [],
    ).then(() => response?.results || []),
  );
});

export const preloadCreateBoardData = async () => {
  createMenuState.setValue({
    isLoadingPhotos: true,
  });

  try {
    const photos = await preloadPhotos();
    const { preSelected } = createMenuState.value.background;
    if (photos?.[0]) {
      preSelected.type = 'unsplash';
      preSelected.id = photos[0].id;
    }
    createMenuState.setValue((current) => ({
      ...current,
      photos,
      isLoadingPhotos: false,
      background: {
        ...current.background,
        preSelected,
      },
    }));
  } catch (err) {
    console.error(err);
    createMenuState.setValue((current) => ({
      ...current,
      photos: [],
      isLoadingPhotos: false,
    }));
  }
};
